export const APPEARANCE_ONBOARDING_VERSION = 1;

export const INTERFACE_STYLES = Object.freeze(["modern", "classic"]);

export const FONT_SCALE_OPTIONS = Object.freeze([
  { value: 0.9, label: "Small", percentage: "90%" },
  { value: 1, label: "Default", percentage: "100%" },
  { value: 1.1, label: "Comfortable", percentage: "110%" },
  { value: 1.2, label: "Large", percentage: "120%" },
  { value: 1.3, label: "Extra Large", percentage: "130%" },
]);

export const DEFAULT_APPEARANCE = Object.freeze({
  interfaceStyle: "modern",
  modernFontScale: 1,
  interfaceChoiceCompleted: false,
  modernFontSetupCompleted: false,
  appearanceOnboardingVersion: 0,
});

export const LAST_INTERFACE_STYLE_KEY = "firmaflow-last-interface-style";

export function isFontScale(value) {
  const numeric = Number(value);
  return FONT_SCALE_OPTIONS.some((option) => option.value === numeric);
}

export function normalizeAppearance(value = {}, fallback = DEFAULT_APPEARANCE) {
  const interfaceStyle = INTERFACE_STYLES.includes(value.interfaceStyle)
    ? value.interfaceStyle
    : INTERFACE_STYLES.includes(value.interface_style)
      ? value.interface_style
      : fallback.interfaceStyle;
  const candidateScale = value.modernFontScale ?? value.modern_font_scale;

  return {
    interfaceStyle,
    modernFontScale: isFontScale(candidateScale) ? Number(candidateScale) : fallback.modernFontScale,
    interfaceChoiceCompleted: Boolean(
      value.interfaceChoiceCompleted ?? value.interface_choice_completed ?? fallback.interfaceChoiceCompleted,
    ),
    modernFontSetupCompleted: Boolean(
      value.modernFontSetupCompleted ?? value.modern_font_setup_completed ?? fallback.modernFontSetupCompleted,
    ),
    appearanceOnboardingVersion: Number(
      value.appearanceOnboardingVersion ?? value.appearance_onboarding_version ?? fallback.appearanceOnboardingVersion,
    ) || 0,
  };
}

export function appearanceCacheKey(userId) {
  return `firmaflow-appearance:${userId}`;
}

export function readAppearanceCache(userId) {
  if (!userId) return null;
  try {
    const value = JSON.parse(localStorage.getItem(appearanceCacheKey(userId)) || "null");
    return value ? normalizeAppearance(value) : null;
  } catch {
    return null;
  }
}

export function writeAppearanceCache(userId, value) {
  if (!userId) return;
  try {
    localStorage.setItem(appearanceCacheKey(userId), JSON.stringify(normalizeAppearance(value)));
  } catch {
    // Storage can be unavailable in private browsing; the database remains authoritative.
  }
}

export function readLastInterfaceStyle() {
  try {
    const value = localStorage.getItem(LAST_INTERFACE_STYLE_KEY);
    return INTERFACE_STYLES.includes(value) ? value : DEFAULT_APPEARANCE.interfaceStyle;
  } catch {
    return DEFAULT_APPEARANCE.interfaceStyle;
  }
}

export function writeLastInterfaceStyle(value) {
  if (!INTERFACE_STYLES.includes(value)) return;
  try {
    localStorage.setItem(LAST_INTERFACE_STYLE_KEY, value);
  } catch {
    // Authentication pages fall back to Modern if browser storage is unavailable.
  }
}
